var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckPortada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.27 18.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.13,
    cy: 9.13,
    r: 8.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.71,6.83a1,1,0,0,0-1.35,0l-3,3L7.17,8.58A.91.91,0,0,0,6.5,8.3a1,1,0,0,0-.67,1.62l1.91,1.91a.85.85,0,0,0,.66.28,1,1,0,0,0,.67-.28l3.62-3.64A1,1,0,0,0,13,7.5.9.9,0,0,0,12.71,6.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPortada);
export default __webpack_public_path__ + "static/media/check_portada.e31b87a0a1a65c8dd4c933562a6ee360.svg";
export { ForwardRef as ReactComponent };